export enum StoreProfileStatus {
  Submitted = 'Submitted',
  Approved = 'Approved',
  Declined = 'Declined',
  Cancelled = 'Cancelled',
  Deleted = 'Deleted',
}
